import { render, staticRenderFns } from "./ProductInUnidentifiedStock.vue?vue&type=template&id=0a99296f"
import script from "./ProductInUnidentifiedStock.vue?vue&type=script&lang=js"
export * from "./ProductInUnidentifiedStock.vue?vue&type=script&lang=js"
import style0 from "./ProductInUnidentifiedStock.vue?vue&type=style&index=0&id=0a99296f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports